module.exports = __webpack_public_path__ + "59c91c04aa040e60c908076f98fcb88e.svg";